import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { WaiverData } from 'src/app/core/models/itinerary.model';
import { SettingsService } from 'src/app/settings/services/settings.service';
import {
  IOsiWaiverTourcodeConfig,
  IOsiWaiverTourcodeVisibleConfig
} from 'src/app/core/models/agency-settings.model';
import {
  ExceptionProcessType,
  OptionType,
  OSIS_VALIDATORS,
  TOURCODE_VALIDATORS
} from 'src/app/core/enums/enums';

const exceptionProcessName = {
  contingency: 'contingency',
  exception: 'exception'
};

@Component({
  selector: 'app-exception-form',
  templateUrl: './exception-form.component.html',
  styleUrls: ['./exception-form.component.scss']
})
export class ExceptionFormComponent implements OnInit, OnDestroy {
  @Input() selectedMode: OptionType;
  @Input() isAirline: boolean;

  @Output() exceptionData = new EventEmitter<WaiverData>();

  subscriptions = new Subscription();

  optionType = OptionType;
  exceptionForm: UntypedFormGroup;
  inputValue = '';
  aditionalFieldsConfig: IOsiWaiverTourcodeConfig = {
    osiEnabled: false,
    waiverEnabled: false,
    tourcodeEnabled: false
  };
  aditionalFieldsVisibleConfig: IOsiWaiverTourcodeVisibleConfig = {
    osiVisible: false,
    waiverVisible: false,
    tourcodeVisible: false
  };
  PROCESS_TYPES = [
    { code: ExceptionProcessType.Contingency, name: exceptionProcessName.contingency },
    { code: ExceptionProcessType.Exception, name: exceptionProcessName.exception }
  ];

  constructor(private fb: UntypedFormBuilder, private settingsService: SettingsService) {}

  ngOnInit() {
    this.buildForm();
    this.callComponentSubscriptions();
  }

  buildForm() {
    this.exceptionForm = this.fb.group({
      processType: [''],
      waiver: [''],
      tourCode: [''],
      osis: this.fb.array([])
    });
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.settingsService.getClientSettings().subscribe((settings) => {
        this.aditionalFieldsConfig = {
          osiEnabled: settings?.exchangeAdditionalFields?.exeption?.osiEnabled,
          waiverEnabled: settings?.exchangeAdditionalFields?.exeption?.waiverEnabled,
          tourcodeEnabled: settings?.exchangeAdditionalFields?.exeption?.tourcodeEnabled
        };
      })
    );
  }

  onChangeExceptionProcess() {
    switch (this.exceptionForm?.value?.processType) {
      case ExceptionProcessType.Contingency:
        if (this.aditionalFieldsConfig.tourcodeEnabled) {
          this.aditionalFieldsVisibleConfig.tourcodeVisible = true;
        }
        this.aditionalFieldsVisibleConfig.osiVisible = false;
        this.aditionalFieldsVisibleConfig.waiverVisible = false;
        break;

      case ExceptionProcessType.Exception:
        if (this.aditionalFieldsConfig.tourcodeEnabled) {
          this.aditionalFieldsVisibleConfig.tourcodeVisible = true;
        }
        if (this.aditionalFieldsConfig.osiEnabled) {
          this.aditionalFieldsVisibleConfig.osiVisible = true;
        }
        this.aditionalFieldsVisibleConfig.waiverVisible = false;
        break;

      default:
        break;
    }
  }

  osis(): UntypedFormArray {
    return this.exceptionForm.get('osis') as UntypedFormArray;
  }

  addOsi(value: string) {
    const osis = this.exceptionForm.controls.osis as UntypedFormArray;
    !!value && osis.push(this.fb.control(value));
  }

  validateAuthApinCode(osiText: string) {
    return osiText.toLowerCase().startsWith(OSIS_VALIDATORS.APIN);
  }

  // *NOTE: Tourcode validator was disabled (2 of 2 places)
  validateTourcode(): boolean {
    if (
      this.exceptionForm.controls.tourCode.value === '' ||
      this.exceptionForm.controls.tourCode.value === null
    ) {
      return false;
    } else {
      if (
        this.exceptionForm.controls.tourCode.value
          .toLowerCase()
          .startsWith(TOURCODE_VALIDATORS.MXLA)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  validateOsis(): boolean {
    if (
      this.exceptionForm.controls.osis.value.length <= 0 ||
      this.exceptionForm.controls.osis.value === null
    ) {
      return false;
    } else {
      if (this.exceptionForm.controls?.osis?.value?.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  validateForm(): boolean {
    if (
      this.aditionalFieldsVisibleConfig.tourcodeVisible &&
      this.aditionalFieldsVisibleConfig.osiVisible
    ) {
      return this.exceptionForm.valid && this.validateOsis();
    } else {
      return this.exceptionForm.valid;
    }
  }

  deleteOsi(index: number) {
    const osis = this.exceptionForm.controls.osis as UntypedFormArray;
    osis.removeAt(index);
  }

  onSubmit() {
    if (this.exceptionForm.valid) {
      this.exceptionData.emit(this.exceptionForm.value as WaiverData);
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
